<template>
  <v-card height="600" color="#f8f9ff" class="d-flex flex-column">
    <v-toolbar color="secondary" class="flex-grow-0 flex-shrink-0" elevation="3" style="z-index: 1">
      <v-toolbar-title class="mr-4">{{ $t('notification_center.notification_center') }}</v-toolbar-title>
      <div class="ms-auto">
        <v-btn v-if="!media.isMobile" text color="primary" class="me-1" @click="$emit('read-all')">
          {{ $t('button.read_all') }}
        </v-btn>
        <v-btn v-if="isNotDisturb" icon color="grey" @click="$emit('toggle-notified')">
          <v-icon class="mx-0">mdi-bell-off</v-icon>
        </v-btn>
        <v-btn v-else icon color="primary" @click="$emit('toggle-notified')">
          <v-icon class="mx-0">mdi-bell</v-icon>
        </v-btn>
      </div>
    </v-toolbar>

    <div v-if="isLoading" class="d-flex align-center justify-center mt-10">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <v-card-text v-else class="flex-grow-1 overflow-y-auto pt-4">
      <slot />
    </v-card-text>

    <v-card-actions v-if="media.isMobile" class="justify-end">
      <v-btn color="secondary" class="primary--text" @click="$emit('close-popup')">
        {{ $t('button.close') }}
      </v-btn>
      <v-btn color="primary" @click="$emit('read-all')">
        {{ $t('button.read_all') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'NotificationCenterCard',
  inject: ['media'],
  props: {
    isNotDisturb: {
      type: Boolean,
      default: false,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
